import * as v from 'valibot';

import type { Entities, Filters, FiltersUpdateApi, Option } from './_core.model';
import { optionSchema, paginatedSchema } from './_core.model';

export const directInterlineApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const directInterlineSchema = v.object({
  ...directInterlineApiSchema.entries,
  ...optionSchema.entries,
});

export const directInterlinesApiSchema = paginatedSchema(directInterlineApiSchema);

export type DirectInterlineApi = v.InferOutput<typeof directInterlineApiSchema>;
export type DirectInterlinesApi = v.InferOutput<typeof directInterlinesApiSchema>;

export type DirectInterlineFilters = Filters<DirectInterlineApi>;

export type DirectInterlineFiltersUpdateApi = FiltersUpdateApi<DirectInterlineApi>;

export type DirectInterline = Prettify<Option<v.InferOutput<typeof directInterlineSchema>>>;

export type DirectInterlines = Entities<DirectInterline>;
